import { urlBuilder } from './builder';

export default urlBuilder(() => '/recovery-password', true);
